export default __webpack_public_path__ + "static/1_35-b311ea5a415896dad903cc6db4d1e14e.png";